/**
 * @generated SignedSource<<1ffeadccbabe94fe342dcd2b18f595e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicSearchResultListTopicSearchEdge$data = ReadonlyArray<{
  readonly node: {
    readonly content: {
      readonly entityId: string;
      readonly " $fragmentSpreads": FragmentRefs<"itemTopicSearchResultListItemTopic">;
    } | null | undefined;
  };
  readonly " $fragmentType": "topicSearchResultListTopicSearchEdge";
}>;
export type topicSearchResultListTopicSearchEdge$key = ReadonlyArray<{
  readonly " $data"?: topicSearchResultListTopicSearchEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicSearchResultListTopicSearchEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "topicSearchResultListTopicSearchEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TopicSearchResultItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "itemTopicSearchResultListItemTopic"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TopicSearchEdge",
  "abstractKey": null
};

(node as any).hash = "cc8e383e5f5ef664ff07821f2f32aa77";

export default node;
